/**
 * @generated SignedSource<<ca9f2406ed2d327ed7f270c9c67e5f11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactLastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactFirstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactEmail",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactPhone",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address1",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address2",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountType",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerStatus",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountStatus",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSoSent",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useBudgets",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "alias": "custPayCount",
  "args": [
    {
      "kind": "Literal",
      "name": "condition",
      "value": {
        "paymentOrder": 0
      }
    }
  ],
  "concreteType": "CustomerAppTsConnection",
  "kind": "LinkedField",
  "name": "customerAppTsByCustomerAccountId",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": "customerAppTsByCustomerAccountId(condition:{\"paymentOrder\":0})"
},
v22 = {
  "alias": "custPayCountBackup",
  "args": [
    {
      "kind": "Literal",
      "name": "condition",
      "value": {
        "paymentOrder": 1
      }
    }
  ],
  "concreteType": "CustomerAppTsConnection",
  "kind": "LinkedField",
  "name": "customerAppTsByCustomerAccountId",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": "customerAppTsByCustomerAccountId(condition:{\"paymentOrder\":1})"
},
v23 = {
  "alias": "resellerSignupCount",
  "args": [
    {
      "kind": "Literal",
      "name": "condition",
      "value": {
        "paymentOrder": 5
      }
    }
  ],
  "concreteType": "CustomerAppTsConnection",
  "kind": "LinkedField",
  "name": "customerAppTsByCustomerAccountId",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": "customerAppTsByCustomerAccountId(condition:{\"paymentOrder\":5})"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerServiceId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingFrequency",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "soAccepted",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Literal",
          "name": "bcStatus",
          "value": 4
        },
        {
          "kind": "Variable",
          "name": "usingAccountId",
          "variableName": "accountId"
        }
      ],
      "kind": "ObjectValue",
      "name": "condition"
    }
  ],
  "concreteType": "BindCardTsConnection",
  "kind": "LinkedField",
  "name": "allBindCardTs",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerAppListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByParentId",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerServiceTsConnection",
            "kind": "LinkedField",
            "name": "customerServiceTsByCustomerAccountId",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerServiceT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v27/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerAppListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByParentId",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerServiceTsConnection",
            "kind": "LinkedField",
            "name": "customerServiceTsByCustomerAccountId",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerServiceT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v28/*: any*/)
        ],
        "storageKey": null
      },
      (v27/*: any*/)
    ]
  },
  "params": {
    "cacheID": "76126d94840d04479410533dde0df734",
    "id": null,
    "metadata": {},
    "name": "CustomerAppListQuery",
    "operationKind": "query",
    "text": "query CustomerAppListQuery(\n  $accountId: UUID!\n) {\n  accountTByAccountId(accountId: $accountId) {\n    accountId\n    accountName\n    contactLastName\n    contactFirstName\n    contactEmail\n    contactPhone\n    address1\n    address2\n    city\n    state\n    country\n    postalCode\n    accountType\n    customerStatus\n    accountStatus\n    lastSoSent\n    useBudgets\n    accountTByParentId {\n      accountName\n      accountId\n      nodeId\n    }\n    custPayCount: customerAppTsByCustomerAccountId(condition: {paymentOrder: 0}) {\n      totalCount\n    }\n    custPayCountBackup: customerAppTsByCustomerAccountId(condition: {paymentOrder: 1}) {\n      totalCount\n    }\n    resellerSignupCount: customerAppTsByCustomerAccountId(condition: {paymentOrder: 5}) {\n      totalCount\n    }\n    customerServiceTsByCustomerAccountId {\n      totalCount\n      nodes {\n        customerServiceId\n        billingFrequency\n        soAccepted\n        nodeId\n      }\n    }\n    nodeId\n  }\n  allBindCardTs(condition: {usingAccountId: $accountId, bcStatus: 4}) {\n    totalCount\n  }\n}\n"
  }
};
})();

node.hash = "95c06bc5c1070662f3104e621f1bbe0e";

module.exports = node;
